document.addEventListener('DOMContentLoaded', function() {
    const pricingCount = document.querySelectorAll(".pricingCount");
    const pricingSwitchMonthly = document.getElementById("pricing-switch-label-monthly");
    const pricingSwitchAnnual = document.getElementById("pricing-switch-label-annual");
    
    if (!pricingSwitchMonthly || !pricingSwitchAnnual) return;

    const pricingSwitch = function (period) {
        const priceAnnual = document.querySelectorAll(".price-annual");
        const priceMonthly = document.querySelectorAll(".price-monthly");
        
        if (period === "annual") {
            priceAnnual.forEach(element => element.classList.remove("hidden"));
            priceMonthly.forEach(element => element.classList.add("hidden"));
            pricingCount.forEach(element => {
                element.innerHTML = element.dataset.yearly;
            });
        } else {
            priceMonthly.forEach(element => element.classList.remove("hidden"));
            priceAnnual.forEach(element => element.classList.add("hidden"));
            pricingCount.forEach(element => {
                element.innerHTML = element.dataset.monthly;
            });
        }
    };

    pricingSwitchMonthly.addEventListener('click', function() {
        pricingSwitchMonthly.classList.add("active");
        pricingSwitchAnnual.classList.remove("active");
        pricingSwitch("monthly");
    });

    pricingSwitchAnnual.addEventListener('click', function() {
        pricingSwitchAnnual.classList.add("active");
        pricingSwitchMonthly.classList.remove("active");
        pricingSwitch("annual");
    });
});
